export default __webpack_public_path__ + "static/media/ZETON_ANIMATOR.ae6c338f.png";